// Full-page layout routes
export default [
  {
    path: "",
    component: () => import("@/layouts/full-page/FullPage.vue"),
    children: [
      // =============================================================================
      // EMBEDDED RECORD VIEW (no navbar / sidebar)
      // =============================================================================
      {
        path: "/modules/embedded/:moduleHash",
        name: "modules-embedded-single-row",
        component: () => import("@/views/custom-modules/view/ViewEmbedded.vue"),
        meta: { rule: "editor" }
      },
      {
        path: "/modules/embedded/:moduleHash/:rowHash",
        name: "modules-embedded-view",
        component: () => import("@/views/custom-modules/view/ViewEmbedded.vue"),
        meta: { rule: "editor" }
      },
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: "/callback",
        name: "auth-callback",
        component: () => import("@/views/Callback.vue"),
        meta: {
          rule: "editor"
        }
      },
      {
        path: "/login",
        name: "page-login",
        component: () => import("@/views/pages/login/Login.vue"),
        meta: {
          rule: "editor"
        }
      },
      {
        path: "/login-checker",
        name: "login-checker",
        component: () => import("@/views/pages/login/LoginChecker.vue"),
        meta: {
          rule: "editor"
        }
      },
      {
        path: "/pages/register",
        name: "page-register",
        component: () => import("@/views/pages/register/Register.vue"),
        meta: {
          rule: "editor"
        }
      },
      {
        path: "/pages/forgot-password",
        name: "page-forgot-password",
        component: () => import("@/views/pages/ForgotPassword.vue"),
        meta: {
          rule: "editor"
        }
      },
      {
        path: "/pages/reset-password",
        name: "page-reset-password",
        component: () => import("@/views/pages/ResetPasswordOnLogin.vue"),
        meta: {
          rule: "editor"
        }
      },
      {
        path: "/pages/reset-password/:rememberToken",
        name: "page-reset-password-by-token",
        component: () => import("@/views/pages/ResetPassword.vue"),
        meta: {
          rule: "editor"
        }
      },
      {
        path: "/pages/lock-screen",
        name: "page-lock-screen",
        component: () => import("@/views/pages/LockScreen.vue"),
        meta: {
          rule: "editor"
        }
      },
      {
        path: "/pages/comingsoon",
        name: "page-coming-soon",
        component: () => import("@/views/pages/ComingSoon.vue"),
        meta: {
          rule: "editor"
        }
      },
      {
        path: "/pages/error-404",
        name: "page-error-404",
        component: () => import("@/views/pages/Error404.vue"),
        meta: {
          rule: "editor"
        }
      },
      {
        path: "/error-500",
        name: "page-error-500",
        component: () => import("@/views/pages/Error500.vue"),
        meta: {
          rule: "editor"
        }
      },
      {
        path: "/pages/not-authorized",
        name: "page-not-authorized",
        component: () => import("@/views/pages/NotAuthorized.vue"),
        meta: {
          rule: "editor"
        }
      },
      {
        path: "/error-403",
        name: "access-denied",
        component: () => import("@/views/pages/AccessDenied.vue"),
        meta: {
          rule: "editor"
        }
      },
      {
        path: "/pages/maintenance",
        name: "page-maintenance",
        component: () => import("@/views/pages/Maintenance.vue"),
        meta: {
          rule: "editor"
        }
      }
    ]
  }
];

